import {genericError} from '../../constants/messages';
import {setLoading, setAlertModal } from './app';
import axiosInstance from '../../utilities/interceptorUtilities';

export const GET_AGENCIES = 'GET_AGENCIES';
export const GET_ENVELOPES = 'GET_RESULTS';
export const GET_STATUSES = 'GET_STATUSES';

export const getAgencies = () => {
    return async (dispatch, getState) => {
        try {
          let isAgent = getState().user.agentAuthenticated ? true : false;
          const url = process.env.REACT_APP_API_URL + `/api/Esignature/GetAgencies?isAgent=${isAgent}`;
          const response = await axiosInstance.post(url, '', {
            withCredentials: true,
          });
          const agencies = response.data;

          if (agencies) {
            dispatch({ type: GET_AGENCIES, agencies });
          } else {
            throw new Error("No agencies found");
          }
        } catch (err) {
          dispatch(setAlertModal(true, 'error', genericError));
          setTimeout(() => {
            dispatch(setAlertModal(false, ''));
          }, 5000);
        }
      };
};

export const setAgency = () => {
  return async (dispatch, getState) => {
      try {
        const url = process.env.REACT_APP_API_URL + `/api/Esignature/GetAgency?agentCode=${getState().user.agentInfo.agentCode}`; 
        const response = await axiosInstance.post(url, '', {
          withCredentials: true,
        });
        const agency = response.data;

        if (agency) {
         dispatch({ type: GET_AGENCIES, agencies: agency});    
        } else {
          throw new Error('No agency found');
        }
      } catch (err) {
          dispatch(setAlertModal(true, 'error', genericError));
          setTimeout(() => {
          dispatch(setAlertModal(false, ''));
        }, 5000);
      }
    };
};

export const getStatuses = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let isAgent = getState().user.agentAuthenticated ? true : false;
      const url = process.env.REACT_APP_API_URL + `/api/Esignature/GetStatuses?isAgent=${isAgent}`;
      const response = await axiosInstance.post(url, '', {
        withCredentials: true,
      });
      const statuses = response.data;

      if (statuses) {
        dispatch({ type: GET_STATUSES, statuses });
      }
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, 'error', genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ''));
      }, 5000);
    }
  };
};

export const sendQuery = (formData) => {
    return async (dispatch, getState) => {
        try {
          dispatch(setLoading(true));
          let isAgent = getState().user.agentAuthenticated ? true : false;
          const url = process.env.REACT_APP_API_URL + `/api/Esignature/GetEnvelopes?isAgent=${isAgent}`;
          formData.UserId = getState().user.agentInfo.userId;
          const body = JSON.stringify(formData);

          const response = await axiosInstance.post(url, body, {
            headers: { 'content-type': 'application/json' },
            withCredentials: true,
          });
          const envelopes = response.data;

          if (envelopes) {
            dispatch({ type: GET_ENVELOPES, envelopes });
          } else {
            dispatch({type: GET_ENVELOPES, envelopes: []});//to wipe out previous search
          }
            dispatch(setLoading(false));
        } catch (err) {
            dispatch(setLoading(false));
            dispatch(setAlertModal(true, 'error', genericError));
            setTimeout(() => {
            dispatch(setAlertModal(false, ''));
          }, 5000);
        }
      };
};